import type { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const BlockSideBySideComponentDefinition: ComponentDefinition = {
    id: 'block-side-by-side',
    name: 'Side by Side',
    category: 'Custom Components',
    children: true,
    slots: {
        buttonsSlot: {
            displayName: 'Buttons',
        },
    },
    variables: {
        overline: {
            displayName: 'Overline',
            type: 'Text',
            defaultValue: 'Overline',
            group: 'content',
        },
        title: {
            displayName: 'Title',
            type: 'Text',
            defaultValue: 'Side by Side',
            group: 'content',
        },
        body: {
            displayName: 'Body',
            type: 'Text',
            defaultValue: 'This is a side by side component.',
            group: 'content',
        },
        imageWrapper: {
            displayName: 'Image Wrapper',
            type: 'Link',
            group: 'content',
            validations: {
                bindingSourceType: ['entry'],
            },
        },
        imagePlacement: {
            displayName: 'Image Placement',
            type: 'Text',
            defaultValue: 'left',
            group: 'style',
            validations: {
                in: [
                    { displayName: 'Left', value: 'left' },
                    { displayName: 'Right', value: 'right' },
                ],
            },
        },
    },
};
